export default __webpack_public_path__ + "static/media/bubble_nova_s2.2d69b574.png";